module.exports = __webpack_public_path__ + "img/token_invalido.0545b80d.png";